import { Fieldset } from '@headlessui/react';
import { JsonSchema, UISchemaElement } from '@jsonforms/core';
import { JsonForms } from '@jsonforms/react';
import { JsonFormsStyleContext, vanillaCells } from '@jsonforms/vanilla-renderers';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { JSONFormData } from '~/types';
import { JSONFormStyles } from './constants';
import { renderers } from './renderers';

type JSONFormProps = {
  formDataSchema: JsonSchema;
  layoutSchema: UISchemaElement;
  defaultValues?: JSONFormData;
};

const KNOWN_LAYOUT_TYPES = new Set([
  'Categorization',
  'Category',
  'Group',
  'HorizontalLayout',
  'Section',
  'VerticalLayout',
]);

const normalizeLayoutSchema = (element: UISchemaElement): UISchemaElement => {
  const layout = element as UISchemaElement & { elements?: UISchemaElement[] };
  if (!Array.isArray(layout.elements)) {
    return element;
  }

  return {
    ...element,
    type: KNOWN_LAYOUT_TYPES.has(element.type) ? element.type : 'VerticalLayout',
    elements: layout.elements.map(normalizeLayoutSchema),
  } as UISchemaElement;
};

export const JSONFormAdapter = (props: JSONFormProps) => {
  const methods = useFormContext();

  const values = methods.watch();
  const JSONSchema = props.formDataSchema;
  const formLayout = useMemo(() => normalizeLayoutSchema(props.layoutSchema), [props.layoutSchema]);

  return (
    <>
      <Fieldset>
        <JsonFormsStyleContext.Provider value={JSONFormStyles}>
          <JsonForms
            schema={JSONSchema}
            uischema={formLayout}
            renderers={renderers}
            cells={vanillaCells}
            data={values}
            validationMode={'ValidateAndShow'}
          />
        </JsonFormsStyleContext.Provider>
      </Fieldset>
    </>
  );
};
